import { Box, Typography } from '@mui/material';

import { daysUntilBoundary, formatDay } from '../benchmarkMonitoring';
import { BENCH } from '../tokens';
import type { MonitoringUpcoming } from '../types';

export function UpNextCard({ upNext, now }: { upNext: MonitoringUpcoming[]; now: Date }) {
  const [next, then] = upNext;
  if (!next) return null;
  const inDays = Math.max(0, daysUntilBoundary(now, next.startAt));
  return (
    <Box
      component="section"
      data-testid="up-next-card"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '24px',
        p: '20px 32px',
        bgcolor: BENCH.cardBg,
        border: `1px solid ${BENCH.divider}`,
        borderRadius: '12px',
        boxSizing: 'border-box',
        width: '100%',
      }}
    >
      <Typography
        component="span"
        sx={{ width: 96, flexShrink: 0, fontFamily: BENCH.font, fontSize: '12px', lineHeight: '16px', fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', color: BENCH.muted }}
      >
        Up next
      </Typography>
      <Box>
        <Typography component="span" sx={{ display: 'block', fontFamily: BENCH.font, fontSize: '20px', lineHeight: '28px', fontWeight: 700, color: BENCH.ink }}>
          {`${next.label} benchmark window`}
        </Typography>
        <Typography component="span" sx={{ display: 'block', fontFamily: BENCH.font, fontSize: '16px', lineHeight: '24px', color: BENCH.muted }}>
          {`Opens ${formatDay(next.startAt)} · in ${inDays} ${inDays === 1 ? 'day' : 'days'}`}
        </Typography>
      </Box>
      {then && (
        <Box sx={{ ml: 'auto', textAlign: 'right' }}>
          <Typography component="span" sx={{ display: 'block', fontFamily: BENCH.font, fontSize: '16px', lineHeight: '24px', color: BENCH.muted }}>
            {`Then ${then.label}`}
          </Typography>
          <Typography component="span" sx={{ display: 'block', fontFamily: BENCH.font, fontSize: '16px', lineHeight: '24px', color: BENCH.muted }}>
            {`Opens ${formatDay(then.startAt)}`}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
